<template>
  <div v-if="showLibrary" class="media-library-selector">
    <v-media-library
      :folders="library.folders"
      :rootFolderName="$t('library.folders.mediathek')"
      :rootFolderIndex="-1"
      :breadcrumbs="currentFolderBreadcrumbs"
      :currentFolder="currentFolder"
      :totalFiles="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.total"
      :loading="customLoading"
      :readOnly="true"
      :selector="true"
      @closeLibrary="closeLibrary"
      @go-to-folder="goToFolder"
      @go-to-previous-folder="goToPreviousFolder"
    >
      <v-row
        v-if="currentFolder && library && library.files && teamsSettings[$route.params.team]"
        slot="files"
        class="mb-0 flex-grow"
      >
        <v-col class="col-12 p-0">
          <div class="flex flex-col h-full">
            <v-list-header complex>
              <v-list-header-cell emptyIcon />
              <v-list-header-cell size="4" :title="$t('library.labels.fileName')" />
              <v-list-header-cell
                :showAs="$t(teamsSettings[$route.params.team].listsSettings.libraryFiles.showAs.firstCol.label)"
                :size="teamsSettings[$route.params.team].listsSettings.libraryFiles.showAs.firstCol.size"
                :showAsDropdownUid="$h.createUniqueUid()"
                :showAsDropdown="showAsFirstColDropdown"
              />
              <v-list-header-cell
                :mobile="$t('actions.sort')"
                :mobileDropdownUid="$h.createUniqueUid()"
                :mobileDropdown="mobileDropdown"
              />
              <v-list-header-cell emptyIcon />
            </v-list-header>
            <ul class="list relative flex-grow">
              <div class="limited-height w-full h-full absolute overflow-y-scroll">
                <library-list-item
                  v-for="file in library.files"
                  :key="'libraryfile_' + file.uid"
                  :file="file"
                  :selectOnly="true"
                  :timezone="teams[$route.params.team].account.timezone"
                  :statiBits="statiBits"
                  :listsSettings="teamsSettings[$route.params.team].listsSettings"
                  :getSelf="getLibraryFile"
                  :currentFolder="currentFolder"
                  :getPreview="getLibraryImagePreview"
                  :team="$route.params.team"
                  :selected="selected"
                  :disabled="checkIfAlreadyAdded(file.uid)"
                  :whitelist="whitelist"
                  :blacklist="blacklist"
                  @selectFile="
                    (file) => {
                      selectFile(file);
                    }
                  "
                >
                </library-list-item>
                <v-list-item v-if="!library.files.length">
                  <v-list-cell :value="$t('library.placeholders.noFiles')"></v-list-cell>
                </v-list-item>
              </div>
            </ul>
            <v-list-pagination
              :currentPage="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.page"
              :showPerPage="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.perPage"
              :totalPages="teamsSettings[$route.params.team].listsSettings.libraryFiles.pagination.lastPage"
              :apiCall="
                (page, perPage) => {
                  changeFilesPage(page, perPage);
                }
              "
            >
            </v-list-pagination>
          </div>
        </v-col>
      </v-row>
    </v-media-library>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import listSettings from "@/mixins/listSettings.js";
import library from "@/mixins/dropdowns/library.js";
import LibraryListItem from "@/views/partials/LibraryListItem.vue";

export default {
  name: "MediaLibrarySelector",
  components: {
    LibraryListItem,
  },
  mixins: [listSettings, library],
  props: {
    showLibrary: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      customLoading: false,
      selected: [],
      selectedObjects: [],
      whitelist: [],
      blacklist: [],
    };
  },
  methods: {
    ...mapActions([
      "getLibraryFoldersList",
      "getLibraryFilesList",
      "getLibraryFolder",
      "getLibraryFile",
      "getLibraryImagePreview",
    ]),
    checkIfAlreadyAdded(uid) {
      if (this.data.files) {
        for (let i = 0; i < this.data.files.length; i += 1) {
          if (this.data.files[i].uid === uid) {
            return true;
          }
        }
      }
      return false;
    },
    initLibrary(uid = false) {
      if (this.data.whitelist) {
        this.whitelist = this.data.whitelist;
      } else {
        this.whitelist = [];
      }
      if (this.data.blacklist) {
        this.blacklist = this.data.blacklist;
      } else {
        this.blacklist = [];
      }
      if (uid) {
        let vm = this;
        this.getLibraryFolder({
          folder: uid,
          setCurrent: true,
          customLoading: true,
        }).then(() => {
          vm.loadPageData();
        });
      } else {
        this.$store.commit("LIBRARY_SET_CURRENT_FOLDER", null);
        this.$store.commit("LIBRARY_SET_CURRENT_FOLDER_META", null);
        this.loadPageData();
      }
    },
    loadPageData() {
      const vm = this;
      this.customLoading = true;
      // this.loadFilterPresets('library')
      // vm.$store.commit('GLOBAL_CUSTOM_LOADING_STARTED')
      let folderP = {
        page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.pagination.page,
        per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.pagination.perPage,
        order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.order.col,
        order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFolders.order.dir,
      };
      let filesP = {
        page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.pagination.page,
        per_page: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.pagination.perPage,
        order_col: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.order.col,
        order_dir: vm.teamsSettings[vm.$route.params.team].listsSettings.libraryFiles.order.dir,
      };
      let folderParams = vm.setFilterRequestObjectFromStore("libraryFolders", folderP);
      let finalFolderParams = {
        folder: vm.currentFolder ? vm.currentFolder.uid : "",
        setListsSettings: true,
        customLoading: true,
        params: folderParams,
      };
      let finalFilesParams = null;
      if (vm.currentFolder) {
        let filesParams = vm.setFilterRequestObjectFromStore("libraryFiles", filesP);
        finalFilesParams = {
          folder: vm.currentFolder.uid,
          setListsSettings: true,
          customLoading: true,
          params: filesParams,
        };
      }
      console.log("vm.currentFolder", vm.currentFolder);
      console.log("params", finalFolderParams, finalFilesParams);
      if (finalFolderParams && finalFilesParams) {
        console.log("LOADING PAGE DATA BOTH", vm.currentFolder, vm.customLoading);
        var p1 = vm.getLibraryFoldersList(finalFolderParams);
        var p2 = vm.getLibraryFilesList(finalFilesParams);
        Promise.all([p1, p2])
          .then(() => {
            // vm.initSort('libraryFiles')
            // vm.initShowAs('libraryFiles')
            // vm.initFilters('libraryFiles')
            vm.customLoading = false;
          })
          .catch(() => {
            vm.customLoading = false;
          });
      } else if (finalFilesParams) {
        vm.getLibraryFilesList(finalFilesParams)
          .then(() => {
            // vm.initSort('libraryFiles')
            // vm.initShowAs('libraryFiles')
            // vm.initFilters('libraryFiles')
            vm.customLoading = false;
          })
          .catch(() => {
            vm.customLoading = false;
          });
      } else {
        vm.getLibraryFoldersList(finalFolderParams)
          .then(() => {
            vm.customLoading = false;
          })
          .catch(() => {
            vm.customLoading = false;
          });
      }
      // this.setSelected();
    },
    // setSelected() {
    //   this.data.files.forEach((file) => {
    //     this.selected.push(file.uid);
    //   });
    // },
    goToFolder(uid) {
      this.initLibrary(uid);
      // this.$router.push({ name: "LibraryFolder", params: { uid: uid } });
    },
    goToPreviousFolder() {
      const vm = this;
      vm.customLoading = true;
      let previousFolder;
      if (vm.currentFolderBreadcrumbs.length > 1) {
        previousFolder = vm.currentFolderBreadcrumbs[vm.currentFolderBreadcrumbs.length - 2].uid;
        // this.$router.push({
        //   name: "LibraryFolder",
        //   params: { uid: previousFolder },
        // });
        this.initLibrary(previousFolder);
      } else {
        // this.$router.push({ name: "Library" });
        this.initLibrary();
      }
    },
    selectFile(file) {
      const index = this.selected.indexOf(file.uid);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        file.folder = this.currentFolder;
        this.selected.push(file.uid);
        this.selectedObjects.push(file);
      }
      if (this.data.autoClose) {
        this.closeLibrary();
      }
    },
    changeFilesPage(page, perPage) {
      let params = {
        page,
        per_page: perPage,
        order_col: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.col,
        order_dir: this.teamsSettings[this.$route.params.team].listsSettings.libraryFiles.order.dir,
      };
      this.getLibraryFiles(params);
    },
    getLibraryFiles(params) {
      if (this.currentFolder) {
        this.filterDropdown[0].options.forEach((option) => {
          if (option.active && option.switch && option.switch.name && !option.select) {
            params[option.switch.name] = option.switch.model;
          }
          if (option.active && option.select && !option.select.custom) {
            params[option.select.name] = this.transformModelToRequestArray(option.select.model);
          }
        });
        this.getLibraryFilesList({
          setListsSettings: true,
          customLoading: true,
          folder: this.currentFolder.uid,
          params,
        }).then(() => {
          // this.checkCurrentFilterPresetHasChanged('libraryFiles')
          // this.initSort('libraryFiles')
        });
      }
    },
    closeLibrary() {
      this.data.selected = this.selected;
      this.data.selectedObjects = this.selectedObjects;
      this.selected = [];
      this.selectedObjects = [];
      this.$eventbus.$emit("closeMediaLibrary", this.data);
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      teamsSettings: "global_get_teams_settings",
      library: "library_get_library_list",
      currentFolder: "library_get_current_folder",
      currentFolderBreadcrumbs: "library_get_current_folder_breadcrumbs",
      filterPresets: "filterpresets_get_filterpresets",
      currentLibraryFilePreviews: "library_get_library_file_previews",
      statiBits: "global_get_fileStatiBits",
      showTips: "global_get_show_tips",
    }),
  },
  watch: {
    showLibrary: function () {
      console.log("showLibrary", this.showLibrary);
      if (this.showLibrary) {
        this.initLibrary();
      }
    },
  },
};
</script>

<style lang="scss">
.media-library-selector {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000000;
  background-color: white;
}
</style>
